// this is generated via google sheet json export
export default {
  seoTitle: "MLS Predictions, MLS Picks and Expert Analysis",
  news: {
    seoTitle: "MLS Sports Betting News | BetQL",
  },
  description:
    "Your source for all the latest MLS predictions. Check out the top MLS picks, value bets and meaningful matchup analysis.",
  "free-pick-predictions": {
    seoTitle: "Free MLS Picks | MLS Predictions | BetQL",
    h1: "BetQL Free MLS Picks",
  },
  "best-bets": {
    seoTitle: "MLS Spreads | MLS Odds | BetQL",
    h1: "MLS Trending Bets",
    description:
      "Check out BetQL for the latest MLS odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
  },
  "line-movement": {
    seoTitle: "MLS Line Movement | BetQL",
    h1: "MLS Line Movement",
    description:
      "Check out BetQL for the latest MLS line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "MLS Line Movement 1st Half Spread | BetQL",
      h1: "MLS 1st Half Spread Line Movement",
      description:
        "Check out BetQL for the latest MLS 1st half spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "MLS Line Movement 1st Half Moneyline | BetQL",
      h1: "MLS 1st Half Line Movement",
      description:
        "Check out BetQL for the latest MLS 1st half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "over-unders": {
      seoTitle: "MLS Line Movement Total | BetQL",
      h1: "MLS Over Under Line Movement",
      description:
        "Check out BetQL for the latest MLS over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-line": {
      seoTitle: "MLS Line Movement 2nd Half Spread | BetQL",
      h1: "MLS 2nd Half Spread Line Movement",
      description:
        "Check out BetQL for the latest MLS 2nd half spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneyline": {
      seoTitle: "MLS Line Movement 2nd Half Moneyline | BetQL",
      h1: "MLS 2nd Half Line Movement",
      description:
        "Check out BetQL for the latest MLS 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    spread: {
      seoTitle: "MLS Spread Line Movement | BetQL",
      h1: "MLS Spread Line Movement",
      description:
        "Check out BetQL for the latest MLS spread line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  odds: {
    seoTitle: "MLS Odds | MLS Lines | BetQL",
    h1: "MLS Model Bets",
    description:
      "Check out BetQL for the latest MLS odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "MLS 1st Half ATS Odds | BetQL",
      h1: "MLS 1st Half Spread Picks",
      description:
        "Check out BetQL for the latest MLS 1st half spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "MLS 1st Half Odds | BetQL",
      h1: "MLS 1st Half Model Bets",
      description:
        "Check out BetQL for the latest MLS 1st half odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "over-unders": {
      seoTitle: "MLS Over Unders | BetQL",
      h1: "MLS Over Under Picks",
      description:
        "Check out BetQL for the latest MLS over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-line": {
      seoTitle: "MLS 2nd Half ATS Odds | BetQL",
      h1: "MLS 2nd Half Spread Picks",
      description:
        "Check out BetQL for the latest MLS 2nd half spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneyline": {
      seoTitle: "MLS 2nd Half Odds | BetQL",
      h1: "MLS 2nd Half Model Bets",
      description:
        "Check out BetQL for the latest MLS 2nd half odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    spread: {
      seoTitle: "MLS Spreads | MLS ATS Picks | BetQL",
      h1: "MLS Spread Model Bets",
      description:
        "Check out BetQL for the latest MLS spread odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "public-betting": {
    seoTitle: "MLS Public Betting | MLS Consensus Picks | BetQL",
    h1: "MLS Consensus Picks",
    description:
      "Check out BetQL for the latest MLS consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "MLS Public Betting 1st Half Spread | BetQL",
      h1: "MLS 1st Half Public Picks ATS",
      description:
        "Check out BetQL for the latest MLS 1st half spread consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "MLS Public Betting 1st Half Moneyline | BetQL",
      h1: "MLS 1st Half Public Picks",
      description:
        "Check out BetQL for the latest MLS 1st half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "over-unders": {
      seoTitle: "MLS Public Betting Total | BetQL",
      h1: "MLS Over Under Public Picks",
      description:
        "Check out BetQL for the latest MLS over under consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-line": {
      seoTitle: "MLS Public Betting 2nd Half Spread | BetQL",
      h1: "MLS 2nd Half Spread Public Picks",
      description:
        "Check out BetQL for the latest MLS 2nd half spread consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneyline": {
      seoTitle: "MLS Public Betting 2nd Half Moneyline | BetQL",
      h1: "MLS 2nd Half Public Picks",
      description:
        "Check out BetQL for the latest MLS 2nd half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    spread: {
      seoTitle: "MLS Public Betting Spread | BetQL",
      h1: "MLS ATS Public Picks",
      description:
        "Check out BetQL for the latest MLS spread consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "sharp-picks": {
    seoTitle: "MLS Picks | MLS Expert Picks | BetQL",
    h1: "MLS Expert Picks ",
    description:
      "Check out BetQL for the latest MLS expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "MLS Sharp Picks 1st Half Spread | BetQL",
      h1: "MLS 1st Half Picks ATS",
      description:
        "Check out BetQL for the latest MLS 1st half spread expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "MLS Sharp Picks 1st Half Moneyline | BetQL",
      h1: "MLS 1st Half Picks",
      description:
        "Check out BetQL for the latest MLS 1st half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "over-unders": {
      seoTitle: "MLS Sharp Picks Total | BetQL",
      h1: "MLS Over Under Picks",
      description:
        "Check out BetQL for the latest MLS over under expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-line": {
      seoTitle: "MLS Sharp Picks 2nd Half Spread | BetQL",
      h1: "MLS 2nd Half Picks ATS",
      description:
        "Check out BetQL for the latest MLS 2nd half spread expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneyline": {
      seoTitle: "MLS Sharp Picks 2nd Half Moneyline | BetQL",
      h1: "MLS 2nd Half Picks",
      description:
        "Check out BetQL for the latest MLS 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    spread: {
      seoTitle: "MLS Picks Against the Spread| BetQL",
      h1: "MLS Picks Against the Spread",
      description:
        "Check out BetQL for the latest MLS 2nd half expert picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
};
